<div class="row mt-5">
    <div class="col-12">
        <h3 class="mt-3">{{ "extensionsOverview.title" | translate }}</h3>
    </div>
</div>

<div class="row mb-3 align-items-end">
    <div class="col-auto">
        <label class="form-label small mb-1">{{ "extensionsOverview.statusFilterLabel" | translate }}</label>
        <select class="form-select form-select-sm" [(ngModel)]="selectedStatus" (ngModelChange)="onStatusFilterChange()">
            @for (opt of statusFilterOptions; track opt.value) {
                <option [value]="opt.value">{{ opt.labelKey | translate }}</option>
            }
        </select>
    </div>
    <div class="col-auto">
        <label class="form-label small mb-1">{{ "extensionsOverview.endMonth" | translate }}</label>
        <input type="month" class="form-control form-control-sm" [(ngModel)]="selectedMonth"
            (ngModelChange)="onMonthFilterChange()">
    </div>
    @if (selectedMonth) {
        <div class="col-auto">
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="clearMonthFilter()">
                {{ "extensionsOverview.clearMonthFilter" | translate }}
            </button>
        </div>
    }
</div>

<div class="row">
    <div class="col-12">
        <ag-grid-angular
            class="ag-theme-alpine"
            style="width: 100%; height: 500px;"
            [rowData]="rowData"
            [columnDefs]="colDefs"
            [defaultColDef]="defaultColDef"
            [rowClassRules]="rowClassRules"
            (gridReady)="onGridReady($event)" />
    </div>
</div>
